import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoins } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';
import Username from './../common/Username';
import Avatar from './../common/Avatar';

const ActivityFeedDKPItem = (props) => (
    <li className="media">
        <div className="row">
            <div className="col-xs-2">
                <Avatar image={props.users[props.item.user].avatar} rank={props.ranks[props.users[props.item.user].rank]} width="32" height="32" />
            </div>
            <div className="col-xs-10">
                <Username user={props.users[props.item.user]} rank={props.ranks[props.users[props.item.user].rank]} placement="left" />
                <span className="activity-date text-muted"> purchased </span>
                <Link to={"/dkp/items/"+props.item.dkpItem.item.slug}>{props.item.dkpItem.item.title}</Link>
                <span className="activity-date text-muted"> for </span>
                <span><FontAwesomeIcon className="text-primary" icon={faCoins} fixedWidth /> {parseFloat(props.item.dkpItem.dkp, 0)} DKP.</span>
                
            </div>
        </div>
    </li>
);

export default ActivityFeedDKPItem;


// WEBPACK FOOTER //
// ./src/ActivityFeed/ActivityFeedDKPItem.js